import * as ProtocolsStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as ProvidersStore from '../../../redux/middleware/ProviderMiddleware';
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';
import { AppState } from '../../../redux/reducers';
import { ErrorType } from '../../../models/HttpError';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';

interface IProps {
  ProtocolId: number | undefined;
  CosnumptionId: string | undefined;
}

interface ConnectedProps {
  isLoading: boolean;
  successLoading: boolean | undefined;
  error: ErrorType | null;
  protocol?: Protocol | null;
  Consumptions: ProtocolConsumption[];
  ProviderId?: number | undefined;
}

interface DispatchProps {
  GetMedicalProtocolById: typeof ProtocolsStore.actionCreators.GetMedicalProtocolById;
  GetConsumptionsBilledInConcept: typeof ProtocolConsumptionStore.ActionCreators.GetConsumptionsBilledInConcept;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
  const AuxProtocol: Protocol | null = state.MedicalProtocols?.list?.find((p: Protocol) => p.id === ownProps.ProtocolId) ?? null;
  // Los consumos facturados dentro del concepto se guardan en billedIn del
  // consumo consultado, junto con sus banderas de carga. El detalle se puede
  // abrir para un consumo de primer nivel o para uno anidado en el
  // childConsumption de su padre, asi que hay que buscar en los dos lados.
  const AuxConsumptions: ProtocolConsumption[] = AuxProtocol?.consumptions || [];
  const AuxConsumption: ProtocolConsumption | null =
    AuxConsumptions.find((c: ProtocolConsumption) => c.id === ownProps.CosnumptionId)
    ?? AuxConsumptions
      .flatMap((c: ProtocolConsumption) => c.childConsumption || [])
      .find((c: ProtocolConsumption) => c.id === ownProps.CosnumptionId)
    ?? null;

  return {
    isLoading: AuxConsumption?.isGettingBilledInConcepts || false,
    successLoading: AuxConsumption?.gettingBilledInConceptsSuccess,
    error: AuxConsumption?.ErrorOnGettingBilledInConcepts ?? null,
    Consumptions: AuxConsumption?.billedIn || [],
    protocol: AuxProtocol,
    ProviderId: undefined,
  };
};

export const mapDispatchToProps = {
  ...ProtocolsStore.actionCreators,
  ...ProvidersStore.actionCreators,
  ...ProtocolConsumptionStore.ActionCreators,
};
